export const SYNC_USERS = '@@users/sync'

export const UPDATE_USERS = '@@users/update'
